import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';

import { PageControlProvider } from './context/PageControlContext';
import { TimerProvider } from './context/TimerContext';

import { DeferUpdateProvider } from './context/DeferUpdateContext';

import { OtpProvider } from './context/OtpContext';

import AppFlow from './AppFlow';
import AppAdmin from './pages/AppAdmin';
import VideoDownload from './pages/VideoDownload';

function App() {

  return (
    <PageControlProvider>
      <TimerProvider>
        <DeferUpdateProvider>
          <OtpProvider>

            <Routes>
              <Route path="/" element={<AppFlow />} />
              <Route path="/app-admin" element={<AppAdmin />} />
              <Route path="/video-download" element={<VideoDownload />} />
            </Routes>

          </OtpProvider>
        </DeferUpdateProvider>
      </TimerProvider>
    </PageControlProvider>
  );

}

export default App;
